import { ScheduleRange } from 'store/scheduleRanges/interfaces';
import { secondsInHour } from 'helpers/timeConsts';

const defaultShift = 8;

export default function getEarliestScheduleShift(
  scheduleRanges: ScheduleRange[],
) {
  let earliestShift = defaultShift * secondsInHour;
  scheduleRanges.forEach((currentShift) => {
    if (currentShift.timeFrom < earliestShift) {
      earliestShift = currentShift.timeFrom;
    }
  });

  return earliestShift / secondsInHour;
}
